"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectReplyBuilder = void 0;
/* eslint-disable import/no-cycle */
const protocol_1 = require("@tonconnect/protocol");
const tweetnacl_util_1 = __importDefault(require("tweetnacl-util"));
const tweetnacl_1 = __importDefault(require("tweetnacl"));
const tonweb_1 = __importDefault(require("tonweb"));
const buffer_1 = require("buffer");
const web_sdk_1 = require("@openproduct/web-sdk");
function getTimeSec() {
    return Math.floor(Date.now() / 1000);
}
const getDomainFromURL = (url) => {
    const parsedURL = new URL(url);
    return parsedURL.hostname;
};
class ConnectReplyBuilder {
    constructor(request, manifest) {
        this.request = request;
        this.manifest = manifest;
    }
    // private static getNetwork () {
    //     return process.env.NETWORK === 'mainnet' ? CHAIN.MAINNET : CHAIN.TESTNET
    // }
    static getNetwork() {
        return protocol_1.CHAIN.MAINNET;
    }
    createTonProofItem(address, secretKey, payload) {
        try {
            const timestamp = getTimeSec();
            // const timestampBuffer = new Int64LE(timestamp).toBuffer()
            const timestampBuffer = buffer_1.Buffer.allocUnsafe(8);
            timestampBuffer.writeBigInt64LE(BigInt(timestamp));
            const domain = getDomainFromURL(this.manifest.url);
            const domainBuffer = buffer_1.Buffer.from(domain);
            const domainLengthBuffer = buffer_1.Buffer.allocUnsafe(4);
            domainLengthBuffer.writeInt32LE(domainBuffer.byteLength);
            const [workchain, addrHash] = address.split(':');
            const addressWorkchainBuffer = buffer_1.Buffer.allocUnsafe(4);
            addressWorkchainBuffer.writeInt32BE(Number(workchain));
            const addressBuffer = buffer_1.Buffer.concat([addressWorkchainBuffer, buffer_1.Buffer.from(addrHash, 'hex')]);
            const messageBuffer = buffer_1.Buffer.concat([
                buffer_1.Buffer.from('ton-proof-item-v2/'),
                addressBuffer,
                domainLengthBuffer,
                domainBuffer,
                timestampBuffer,
                buffer_1.Buffer.from(payload)
            ]);
            //   const message = createHash('sha256').update(messageBuffer).digest();
            const bufferToSign = buffer_1.Buffer.concat([
                buffer_1.Buffer.from('ffff', 'hex'),
                buffer_1.Buffer.from('ton-connect'),
                buffer_1.Buffer.from((0, web_sdk_1.sha256_sync)(messageBuffer))
            ]);
            const signed = tweetnacl_1.default.sign.detached(buffer_1.Buffer.from((0, web_sdk_1.sha256_sync)(bufferToSign)), secretKey);
            const signature = tweetnacl_util_1.default.encodeBase64(signed);
            return {
                name: 'ton_proof',
                proof: {
                    timestamp,
                    domain: {
                        lengthBytes: domainBuffer.byteLength,
                        value: domain
                    },
                    signature,
                    payload
                }
            };
        }
        catch (e) {
            return {
                name: 'ton_proof',
                error: {
                    code: 0,
                    message: 'Wallet internal error'
                }
            };
        }
    }
    createReplyItems(addr, privateKey, publicKey, walletStateInit) {
        const address = new tonweb_1.default.utils.Address(addr).toString(false, true, true);
        const replyItems = this.request.items.map((requestItem) => {
            switch (requestItem.name) {
                case 'ton_addr':
                    return {
                        name: 'ton_addr',
                        address,
                        network: ConnectReplyBuilder.getNetwork(),
                        publicKey,
                        //  Buffer.from(publicKey).toString('hex'),
                        walletStateInit
                    };
                case 'ton_proof':
                    return this.createTonProofItem(address, privateKey, requestItem.payload);
                default:
                    return {
                        name: requestItem.name,
                        error: { code: 400 }
                    };
            }
        });
        return replyItems;
    }
    static createAutoConnectReplyItems(addr, publicKey, walletStateInit) {
        const address = new tonweb_1.default.utils.Address(addr).toString(false, true, true);
        return [
            {
                name: 'ton_addr',
                address,
                network: ConnectReplyBuilder.getNetwork(),
                publicKey: buffer_1.Buffer.from(publicKey).toString('hex'),
                walletStateInit
            }
        ];
    }
}
exports.ConnectReplyBuilder = ConnectReplyBuilder;
